import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as api from '../../api'
import ApiDataProvider from "../../components/table/data-providers/api-data-provider";
import { Grid } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import WithoutFilterableDatatable from "../../components/table/data-table-without-filterable";
import 'filepond/dist/filepond.min.css';
import ReactGA from 'react-ga';
import { Helmet } from 'react-helmet';
import DataMapsTableHeader from './datamaps-table-header';
import DataMapsTableRow from './datamaps-table-row';

function mapStateToProps(state) {
    return {

    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {

    };
}

class DataMaps extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dataProvider: new ApiDataProvider(api.getDataMapsList, [this.props.customerId]),
            documentsCount: {},
            files: [],
            updatedKey : 0
        }

    
    }

    componentDidMount = () => {
       
        ReactGA.pageview('datamaps');
    };
    


    render() {


        return (
            <div className="main-container">
                <Helmet>
                    <title>Inenco Portal | Data Maps</title>
                </Helmet>
                
                <Grid.Row>
                <Grid.Column>
                            <h2>Data Mapper</h2>
                        </Grid.Column>
                    <Grid.Column>
                        <div className="table-container">
                            <WithoutFilterableDatatable dataProvider={this.state.dataProvider} name="DataMaps" canExport={false} allowFileMetadata={true} startingLimit="All"
                                contextData={{ customerId: this.props.customerId }}  key={this.state.updatedKey}
                                headerComponent={DataMapsTableHeader} rowComponent={DataMapsTableRow} />
                        </div>
                    </Grid.Column>
                </Grid.Row>
            </div>
        );
    }
}

const wrap = connect(mapDispatchToProps, mapStateToProps);
export default wrap(DataMaps);